import { createContext } from 'react';
import { ApplePayEventsEnum, GooglePayEventsEnum } from '@capacitor-community/stripe';
import { InitiateTransactionParams } from './types';

export interface StripePaymentsContextType {
  isApplePayAvailable?: boolean;
  isGooglePayAvailable?: boolean;
  initiateApplePayTransaction: (params: InitiateTransactionParams) => Promise<ApplePayEventsEnum | null>;
  initiateGooglePayTransaction: (params: InitiateTransactionParams) => Promise<GooglePayEventsEnum | null>;
  countryCode: string;
}

export const StripePaymentsContext = createContext<StripePaymentsContextType>({} as StripePaymentsContextType);
